import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { MarshaPhoto, JuliePhoto, DeepaPhoto, SophiePhoto } from '../../assets'
import { User } from '../../types'
import { useGetOfficersQuery } from 'redux/services/userService'
import { Link } from 'react-router-dom'

export const ExecutiveCommittee: React.FC = () => {
  const {
    data: officers,
    isFetching,
    isError,
    isLoading
  } = useGetOfficersQuery()

  const headshots: Record<string, string> = {
    Deepa: DeepaPhoto,
    Julie: JuliePhoto,
    Marsha: MarshaPhoto,
    Sophie: SophiePhoto
  }

  const [sortedOfficers, setSortedOfficers] = React.useState<User[]>([])

  React.useEffect(() => {
    const tempArray: User[] = []
    if (officers) {
      officers.forEach((officer: User) => {
        if (officer.firstName === 'Julie') {
          tempArray.splice(0, 0, officer)
        } else if (officer.firstName === 'Sophie') {
          tempArray.splice(1, 0, officer)
        } else if (officer.firstName === 'Deepa') {
          tempArray.splice(2, 0, officer)
        } else {
          tempArray.splice(3, 0, officer)
        }
      })
    }
    setSortedOfficers(tempArray)
  }, [officers])

  return (
    <main className="static-page-main py-8 bg-[#EDE6DE]">
      <div className="flex justify-center mb-8">
        <h3 className="text-4xl font-bold text-[#3C2416]">
          Meet our Executive Committee
        </h3>
      </div>
      <section className="max-w-11/12 mx-auto xl:max-w-3/4 xl:px-8">
        {isFetching ? (
          <SkeletonTheme baseColor="#EDE6DE" highlightColor="#9298a8">
            <ul className="space-y-12 lg:grid lg:grid-cols-2 lg:items-stretch lg:gap-x-8 lg:gap-y-16 lg:space-y-0">
              {[1, 2, 3, 4].map((index) => (
                <li key={index} className="h-full">
                  <div className="grid grid-cols-3 items-start gap-x-8 align-middle h-full">
                    <div className="col-span-1">
                      <Skeleton height={300} className="rounded-lg" />
                    </div>
                    <div className="col-span-2 space-y-4">
                      <Skeleton height={24} width={200} />
                      <Skeleton height={24} width={180} />
                      <Skeleton count={3} height={20} />
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </SkeletonTheme>
        ) : !isError && !isLoading && officers ? (
          <ul className="space-y-6 lg:grid lg:grid-cols-2 lg:items-stretch lg:gap-x-8 lg:gap-y-6 lg:space-y-0">
            {sortedOfficers.map((officer) => (
              <li key={officer.firstName} className="h-full">
                <div className="bg-white rounded-lg p-6 shadow-md h-full flex flex-col">
                  <div className="grid grid-cols-3 items-start gap-x-8 flex-grow">
                    <div className="col-span-1">
                      <img
                        src={headshots[officer.firstName]}
                        alt={`Headshot for ${officer.firstName} ${officer.lastName}`}
                        className="rounded-lg shadow-lg object-cover aspect-[3/4] w-full"
                      />
                    </div>
                    <div className="col-span-2 space-y-3">
                      <h3 className="text-2xl font-semibold text-[#142841]">
                        Dr. {officer.firstName} {officer.lastName}
                      </h3>
                      <p className="text-xl font-medium text-[#A6410A]">
                        {officer.position}
                      </p>
                      <div className="min-h-[200px]">
                        <p className="text-[#142841] leading-relaxed">
                          {officer.bio}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center text-[#A6410A] py-4">
            Error retrieving officers. Please try refreshing the page.
          </div>
        )}
      </section>

      <section className="max-w-9/12 mx-auto px-4 sm:px-6 lg:px-8 mt-16">
        <h3 className="text-3xl font-bold text-[#142841] mb-6">
          Conflict of Interest Policies
        </h3>
        <p className="text-[#142841]">
          You can find NASCC&apos;s conflict of interest policy{' '}
          <Link
            to="/conflict_of_interest"
            className="text-[#A6410A] hover:text-[#8a3608] underline"
          >
            here
          </Link>
          .
        </p>
      </section>
    </main>
  )
}
